import { render, staticRenderFns } from "./buscaExame.vue?vue&type=template&id=378231f0&scoped=true&"
import script from "./buscaExame.vue?vue&type=script&lang=js&"
export * from "./buscaExame.vue?vue&type=script&lang=js&"
import style0 from "./buscaExame.vue?vue&type=style&index=0&id=378231f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378231f0",
  null
  
)

export default component.exports